// Added by Sejune Oh on 2020-02-20
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC, RefObject } from 'react'
import { withStyles, Theme, createStyles, WithStyles } from '@material-ui/core'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import Intl from '@/helper/Intl'
import { ReactFormEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { UserCustomInfoProp } from '@/stores/mgmt/user/UserStore'
import Input from '@/components/common/Input'
import Dialog from '@/components/common/Dialog'
import Select from '@/components/common/Select'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface CustomInfoDialogFCProps extends WithStyles<typeof styles> {
    dialogRef: RefObject<Dialog>
    onDialogConfirm: () => Promise<{}>
    customInfoElement?: UserCustomInfoProp
    formId: string
    onFormSubmit: ReactFormEvent
    menuItems: string[]
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const CustomInfoDialog: FC<CustomInfoDialogFCProps> = ({ classes, customInfoElement, menuItems, ...props }) => {
    const labelKey = Intl.getIntlText({ id: 'htmljs_react.mgmt.custominfodialog.label_key' })
    const labelValue = Intl.getIntlText({ id: 'htmljs_react.mgmt.custominfodialog.label_value' })

    if (menuItems.length === 0) return null
    return (
        <Dialog ref={props.dialogRef} onConfirm={props.onDialogConfirm}>
            <form id={props.formId} className={classes.FormWrapper} onSubmit={props.onFormSubmit}>
                <div className={classes.RowWrapper}>
                    <Select
                        id="key"
                        label={labelKey}
                        menuItems={menuItems}
                        value={(customInfoElement ? customInfoElement.key : menuItems[0]) || ''}
                        disabled={!!customInfoElement}
                        isFullWidth={true}
                    />
                </div>
                <Input
                    id={'value'}
                    type="string"
                    label={labelValue}
                    isFullWidth={true}
                    defaultValue={customInfoElement ? customInfoElement.value : ''}
                />
            </form>
        </Dialog>
    )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Styles
const styles = (theme: Theme) =>
    createStyles({
        FormWrapper: {
            overflow: 'hidden',
        },
        RowWrapper: {
            display: 'flex',
            width: '100%',
        },
    })

export default withStyles(styles, { withTheme: true })(CustomInfoDialog)
